<span class="badge badge-cliente-analise-mercado-status-projetado-badge badge-cliente-analise-mercado-status-projetado-badge-ganho"
    [title]="getTitle()">
    {{status.nome}}    
</span>